export default __webpack_public_path__ + "acbdd9513d7af2882303e41f2cc01275.svg";